import { Avatar, Box, Button, Divider, Stack, Typography } from "@mui/material"
import { CheckCircle as CheckCircleIcon } from '@mui/icons-material';
import { QuestionMarkIcons } from "../../global/Icons";

export const DailyTask = ({toolOwnedList}) => {

    return (
        <Box width="100%" height="700px" bgcolor="#FFFFFF" borderRadius="12px" p="24px">
            <Box width="100%" height="100%" display="flex" flexDirection="column" gap="16px">
                <Box minHeight="19px" display="flex" alignItems="center" gap="12px">
                    <Typography fontWeight={600} fontSize={16} lineHeight="120%" letterSpacing="-0.75%">Daily Task</Typography>
                    <Typography fontWeight={600} fontSize={16} lineHeight="120%" letterSpacing="-0.75%" color="#5DB55D">Info</Typography>
                </Box>
                <Box minHeight="87px" display="flex">
                    <Stack height="100%" width="320px" p={2} gap={1.5} bgcolor="#FBFCFB" borderRadius="12px" justifyContent="center">
                        <Stack direction="row" alignItems="center" gap="12px">
                           <Typography fontWeight={400} fontSize={14} lineHeight="120%" letterSpacing="-0.75%" color="#292C2F">Task Rate</Typography>
                           <QuestionMarkIcons/>
                        </Stack>
                        <Stack direction="row" alignItems="center" gap="16px">
                            <Typography fontWeight={700} fontSize={20} lineHeight="132%" letterSpacing="-1%" color="#292C2F">80%</Typography>
                            <Box height="26px" p="4px 12px 4px 12px" bgcolor="#292C2F" borderRadius="12px">
                                <Typography fontWeight={400} fontSize={12} lineHeight="147%" letterSpacing="0%" color="#F2FFF2">Ordinary</Typography>
                            </Box>
                        </Stack>
                    </Stack>
                </Box>
                <Box height="100%" width="100%" className="overflowY">
                    <Stack width="100%" divider={<Divider flexItem />}>
                        {toolOwnedList?.map((v,k) => { 
                            const status = Math.floor(Math.random() * 2) + 1
                            return (
                                <Stack key={k} height="71px" width="100%" direction="row" alignItems="center" gap="12px" px={2}>
                                    <Avatar src={JSON.parse(v.logo)} variant="square" sx={{height:'32px', width:'32px', borderRadius:'4px'}}/>
                                    <Stack width="100%" minWidth={0} gap="8px">
                                        <Typography fontWeight={400} fontSize={14} lineHeight="147%" letterSpacing="0%" color="#292C2F">{v.name}</Typography>
                                        <Typography fontSize={12} fontWeight={400} lineHeight="147%" letterSpacing="0%" color="#5B6167" noWrap>
                                            {v.description}
                                        </Typography>
                                    </Stack>
                                    {status === 1 ?
                                        <Button sx={{height:'36px', width:'48px', borderRadius:'4px', bgcolor:'#003022','&:hover':{bgcolor:'#003F2E'} }}>
                                            <Typography fontSize={12} fontWeight={400} lineHeight="142%" letterSpacing="0%" color="#FFFFFF">Proceed</Typography>
                                        </Button>
                                    :
                                        <Button endIcon={<CheckCircleIcon sx={{height:'20px', width:'20px'}}/>} sx={{height:'36px', width:'48px', borderRadius:'4px', bgcolor:'#FFFFFF','&:hover':{bgcolor:'#FFFFFF'} }}>
                                            <Typography fontSize={12} fontWeight={400} lineHeight="142%" letterSpacing="0%" color="#22A06B">Done</Typography>
                                        </Button>
                                    }
                                </Stack>
                            )
                        })}
                    </Stack>
                </Box>
                <Box minHeight="18px">
                    <Typography fontWeight={400} fontSize={12} lineHeight="147%" letterSpacing="-0.75%" color="#5B6167">Total Count {toolOwnedList.length}</Typography>
                </Box>
            </Box>
        </Box>
    )
}